import React, { useState } from 'react';
import { Card, Form, Switch, Col, Row, Alert } from 'antd';

export interface CalendarAvailabilityConfig {
    calendarShowCounts: boolean;
    calendarShowLegend: boolean;
    includeDescendants: boolean;
}

const DEFAULT_CONFIG: CalendarAvailabilityConfig = {
    calendarShowCounts: true,
    calendarShowLegend: true,
    includeDescendants: false,
};

interface Props {
    initialConfig?: Partial<CalendarAvailabilityConfig>;
    onChange: (config: CalendarAvailabilityConfig) => void;
}

export const SectionConfigCalendarAvailability: React.FC<Props> = ({ initialConfig, onChange }) => {
    const [config, setConfig] = useState<CalendarAvailabilityConfig>({
        ...DEFAULT_CONFIG,
        ...initialConfig,
    });

    const updateField = (field: keyof CalendarAvailabilityConfig, value: boolean) => {
        const next = { ...config, [field]: value };
        setConfig(next);
        onChange(next);
    };

    return (
        <Card size="small" style={{ background: '#f5f5f5' }}>
            <Alert
                message="Calendar Availability"
                description="Shows which days contain measurements for the selected area."
                type="info"
                showIcon
                style={{ marginBottom: 16 }}
            />
            <Row gutter={12}>
                <Col span={8}>
                    <Form.Item label="Show counts">
                        <Switch
                            checked={config.calendarShowCounts}
                            onChange={(checked) => updateField('calendarShowCounts', checked)}
                        />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label="Show legend">
                        <Switch
                            checked={config.calendarShowLegend}
                            onChange={(checked) => updateField('calendarShowLegend', checked)}
                        />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label="Include child areas">
                        <Switch
                            checked={config.includeDescendants}
                            onChange={(checked) => updateField('includeDescendants', checked)}
                        />
                    </Form.Item>
                </Col>
            </Row>
        </Card>
    );
};

export default SectionConfigCalendarAvailability;
